import { render, staticRenderFns } from "./ExpirationList.vue?vue&type=template&id=6497fe65&scoped=true&"
import script from "./ExpirationList.vue?vue&type=script&lang=ts&"
export * from "./ExpirationList.vue?vue&type=script&lang=ts&"
import style0 from "./ExpirationList.vue?vue&type=style&index=0&id=6497fe65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6497fe65",
  null
  
)

export default component.exports